export default {
  title: 'Pagar com PayPal',
  error: 'O pagamento PayPal não pôde ser concluído. Tente novamente.',
};
